import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { type IncidentNote } from '@api/incidents';

@Component({
  imports: [CommonModule],
  selector: 'avs-incident-note',
  styleUrl: './incident-note.component.scss',
  templateUrl: './incident-note.component.html',
})
export class IncidentNoteComponent {
  note = input.required<IncidentNote>();
}
